import React from 'react'
import PropTypes from 'prop-types'
import { hot } from 'react-hot-loader/root'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'

import Modals from './Modals/index'
import Header from './Header'
import Footer from './Footer'
import Report from './Report'

class Layout extends React.Component {
    render() {
        const { showReport, dialog, modalProps } = this.props
        const Modal = Modals[dialog]

        return (
            <>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {dialog && <Modal {...modalProps} />}
                {showReport && <Report />}
                <div id="SharePortal" />

                <h1 className="is-hidden">Site Check</h1>

                <Header showFeedback={this.showFeedback} />

                <Outlet />

                <Footer />
            </>
        )
    }
}

Layout.propTypes = {
    // redux state
    showReport: PropTypes.bool.isRequired,
    dialog: PropTypes.string.isRequired,
    modalProps: PropTypes.shape({})
}

Layout.defaultTypes = {
    modalProps: {}
}

export { Layout as _Layout }
export default hot(
    connect(({ report: { show: showReport }, navigation: { dialog, modalProps } }) => ({
        showReport: showReport || false,
        dialog: dialog || '',
        modalProps: modalProps || {}
    }))(Layout)
)
